/* Brand My Cap – product page: colour gallery carousel, description under price, wording tweaks */
(function () {
  'use strict';
  var dataEl = document.getElementById('bmc-product-json');
  if (!dataEl) return;
  var P = JSON.parse(dataEl.textContent);
  var VIEWS = ['front', 'three', 'quarter', '34', 'left', 'right', 'side', 'back', 'top', 'under', 'detail', 'hero'];
  var RANK = { front: 0, three: 1, quarter: 1, '34': 1, left: 2, side: 3, right: 4, back: 5, top: 6, under: 7 };

  function fname(src) {
    return (src || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '').toLowerCase()
      .replace(/_[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/, '');
  }
  function parse(src) {
    var t = fname(src).split(/[_\s-]+/);
    for (var i = 0; i < t.length; i++) if (VIEWS.indexOf(t[i]) > -1) return { prefix: t.slice(0, i).join('_'), view: t[i] };
    return { prefix: '', view: '' };
  }

  var media = (P.media || []).filter(function (m) { return m.media_type === 'image' || m.preview_image; });
  media.forEach(function (m, i) {
    m._src = m.src || (m.preview_image && m.preview_image.src);
    m._p = parse(m._src);
    m._i = i;
  });
  /* If a colour has lost its photo link (e.g. after a supplier sync), find its photo by file name:
     "Black/White" -> Black_White_Front, Blackwhite_Front; "Red" -> Red_Front, Redred_Front */
  function nrm(x) { return String(x || '').toLowerCase().replace(/[^a-z]/g, ''); }
  function colourOf(v) {
    var s = String(v.option1 || v.title || '');
    if (s.indexOf(' - ') > -1) s = s.split(' - ').slice(1).join(' - ');
    return s.split(' / ')[0].split(',')[0].trim();
  }
  /* Photo labels (alt text) can name the colour, e.g. "Navy" or "Ice Beanie – Navy" */
  function altColour(m) {
    var a = String(m.alt || '');
    if (a.indexOf(' – ') > -1) a = a.split(' – ').pop();
    return nrm(a);
  }
  function findColourMedia(col) {
    var parts = col.split(/\s*\/\s*/).map(nrm).filter(Boolean);
    if (!parts.length) return null;
    var uniq = parts.filter(function (x, i) { return parts.indexOf(x) === i; });
    var keys = [parts.join(''), uniq.join('')];
    if (parts.length === 1) keys.push(parts[0] + parts[0]);
    var best = null, bestR = 99;
    media.forEach(function (m) {
      if (keys.indexOf(nrm(m._p.prefix)) < 0 && keys.indexOf(altColour(m)) < 0) return;
      var r = RANK[m._p.view];
      r = r == null ? 9 : r;
      if (r < bestR) { best = m; bestR = r; }
    });
    return best;
  }
  P.variants.forEach(function (v) {
    if (v.featured_media) return;
    var m = findColourMedia(colourOf(v));
    if (m) v.featured_media = { id: m.id, preview_image: { src: m._src } };
  });
  var anchors = {};
  P.variants.forEach(function (v) { if (v.featured_media) anchors[v.featured_media.id] = true; });

  function groupFor(variant) {
    var fm = variant && variant.featured_media;
    /* a colour without its own photo: just the main photo, unless no colour has photos */
    if (!fm) return Object.keys(anchors).length && media.length ? [media[0]] : media;
    var a = null;
    media.forEach(function (m) { if (m.id === fm.id) a = m; });
    if (!a) return media;
    var g = [];
    if (a._p.prefix) {
      var ap = nrm(a._p.prefix);
      g = media.filter(function (m) { return nrm(m._p.prefix) === ap; });
      /* keep one photo per view (a re-imported front can duplicate the original) */
      var seenView = {};
      g = g.filter(function (m) {
        if (m.id === a.id) return true;
        var k = m._p.view || m.id;
        if (k === a._p.view) return false;
        if (seenView[k]) return false;
        seenView[k] = 1;
        return true;
      });
    }
    if (g.length < 2 && altColour(a)) {
      var aa = altColour(a);
      g = media.filter(function (m) { return altColour(m) === aa; });
      if (g.length >= media.length || aa === nrm(P.title)) g = [];
    }
    if (g.length < 2) {
      g = [a];
      var ac = altColour(a);
      for (var i = a._i + 1; i < media.length && !anchors[media[i].id]; i++) {
        if (ac && altColour(media[i]) && altColour(media[i]) !== ac) break; /* next photo is labelled as another colour */
        g.push(media[i]);
      }
    }
    g.sort(function (x, y) {
      if (x.id === a.id) return -1;
      if (y.id === a.id) return 1;
      var rx = RANK[x._p.view], ry = RANK[y._p.view];
      return (rx == null ? 9 : rx) - (ry == null ? 9 : ry) || x._i - y._i;
    });
    return g;
  }

  function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function currentVariant() {
    var inp = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    var id = inp ? Number(inp.value) : Number(new URLSearchParams(location.search).get('variant'));
    for (var i = 0; i < P.variants.length; i++) if (P.variants[i].id === id) return P.variants[i];
    return P.variants[0];
  }

  /* ---------- Gallery ---------- */
  var gallery, track, thumbs, counter, shownKey = '';
  function buildGallery() {
    var mg = document.querySelector('media-gallery');
    if (!mg || !media.length) return;
    gallery = document.createElement('div');
    gallery.className = 'bmc-pg';
    gallery.innerHTML =
      '<div class="bmc-pg__stage">' +
      '<button type="button" class="bmc-pg__nav bmc-pg__nav--prev" aria-label="Previous image">&#8249;</button>' +
      '<ul class="bmc-pg__track" role="list"></ul>' +
      '<button type="button" class="bmc-pg__nav bmc-pg__nav--next" aria-label="Next image">&#8250;</button>' +
      '<span class="bmc-pg__count"></span></div>' +
      '<ul class="bmc-pg__thumbs" role="list"></ul>';
    mg.parentNode.insertBefore(gallery, mg);
    mg.classList.add('bmc-hidden-gallery');
    track = gallery.querySelector('.bmc-pg__track');
    thumbs = gallery.querySelector('.bmc-pg__thumbs');
    counter = gallery.querySelector('.bmc-pg__count');
    gallery.querySelector('.bmc-pg__nav--prev').addEventListener('click', function () { go(-1); });
    gallery.querySelector('.bmc-pg__nav--next').addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(markActive, 60);
    });
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]');
      if (b) show(Number(b.dataset.i));
    });
    track.addEventListener('click', function (e) {
      var im = e.target.closest('img');
      if (im) openZoom(im.dataset.full);
    });
    render();
  }
  function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
  function show(i) {
    var n = track.children.length;
    i = (i + n) % n;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    setTimeout(markActive, 350);
  }
  function go(d) { show(index() + d); }
  function markActive() {
    var i = index();
    [].forEach.call(thumbs.children, function (t, j) { t.classList.toggle('is-active', i === j); });
    counter.textContent = (i + 1) + ' / ' + track.children.length;
  }
  function render() {
    if (!gallery) return;
    var v = currentVariant();
    var g = groupFor(v);
    var key = g.map(function (m) { return m.id; }).join(',');
    if (key === shownKey) return;
    shownKey = key;
    track.innerHTML = g.map(function (m, i) {
      return '<li class="bmc-pg__slide"><img src="' + sized(m._src, 1100) + '" data-full="' + sized(m._src, 2000) + '" alt="' + (m.alt || P.title).replace(/"/g, '&quot;') + '" ' + (i ? 'loading="lazy" ' : '') + 'width="1100" height="1100"></li>';
    }).join('');
    thumbs.innerHTML = g.length > 1 ? g.map(function (m, i) {
      return '<li><button type="button" data-i="' + i + '" aria-label="Show image ' + (i + 1) + '"><img src="' + sized(m._src, 160) + '" alt="" loading="lazy" width="80" height="80"></button></li>';
    }).join('') : '';
    gallery.classList.toggle('is-single', g.length < 2);
    track.scrollLeft = 0;
    markActive();
  }
  function openZoom(src) {
    var o = document.createElement('div');
    o.className = 'bmc-zoom';
    o.innerHTML = '<img src="' + src + '" alt=""><button type="button" aria-label="Close">&times;</button>';
    o.addEventListener('click', function () { o.remove(); });
    document.body.appendChild(o);
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(render, 80);
  });
  document.addEventListener('bmc:variant', function () { setTimeout(render, 20); });
  window.addEventListener('popstate', function () { setTimeout(render, 80); });

  /* ---------- Description under the price, enquiry wording ---------- */
  function placeDescription() {
    var d = document.getElementById('bmc-desc');
    if (!d) return;
    var price = document.querySelector('.product__info-container [id^="price-"], .product__info-wrapper [id^="price-"]');
    if (price) { price.parentNode.insertBefore(d, price.nextSibling); d.hidden = false; }
  }
  function wording() {
    var q = document.getElementById('trigger-enquiry');
    if (q) q.textContent = 'Unsure about anything? Send us your questions!';
  }

  /* Variant buttons: drop a size suffix every option shares (e.g. " / Standard Size") */
  function tidyLabels() {
    document.querySelectorAll('.product-form__input .swatch-group').forEach(function (g) {
      var ls = [].slice.call(g.querySelectorAll('label:not(.swatch-variant-color)'));
      if (ls.length < 2) return;
      var tx = ls.map(function (l) { return l.textContent.trim(); });
      var m = tx[0].match(/\s\/\s[^\/]+$/);
      if (!m) return;
      var suf = m[0];
      if (!tx.every(function (t) { return t.slice(-suf.length) === suf; })) return;
      ls.forEach(function (l, i) { l.textContent = tx[i].slice(0, -suf.length); l.title = tx[i]; });
    });
  }

  /* Colour buttons -> small front images of each colour */
  function variantImage(v) {
    if (!v) return '';
    if (v.featured_media && v.featured_media.preview_image) return v.featured_media.preview_image.src;
    if (v.featured_image) return v.featured_image.src;
    return '';
  }
  var CHIP = {
    black: '#111', white: '#f4f4f4', cream: '#efe6cf', ivory: '#f2ecdc', natural: '#e8dcc0', navy: '#1c2a4a', blue: '#2d5bd1', royal: '#2448b8',
    sky: '#8cc4ec', powder: '#b6d3ec', aqua: '#3cc6c8', turquoise: '#26b4b4', teal: '#14807e', petrol: '#1f5560', denim: '#3d5a80',
    grey: '#9a9a9a', heather: '#a7a7a7', melange: '#a0a0a0', charcoal: '#444', graphite: '#4a4a4a', slate: '#6b7580', steel: '#5f7d95',
    red: '#c8202a', maroon: '#6a1b25', burgundy: '#701c2c', cerise: '#d6246e', pink: '#f2a0bf', coral: '#f57e6e', fuchsia: '#d6247a',
    orange: '#f07a1a', rust: '#a94a22', mustard: '#d9a62b', gold: '#d4a017', yellow: '#f5e03a', lemon: '#f6e85a', sunflower: '#f2c21b',
    green: '#2f8a3c', bottle: '#1f4a2c', emerald: '#14825a', lime: '#9bd12c', olive: '#5c6b2e', army: '#4b5320', forest: '#24452c', mint: '#a8dcc0', kelly: '#2aa63d', neon: '#c8ff2e',
    khaki: '#b9a77c', stone: '#cfc4a8', sand: '#d8c49c', beige: '#d9c8a6', tan: '#c19a6b', caramel: '#b0703a', brown: '#6b4428', chocolate: '#4a2c1b',
    whiskey: '#9a5a26', camel: '#c19a6b', purple: '#6a3d9a', lilac: '#c4a8dc', silver: '#c0c0c0', light: '', dark: ''
  };
  function colourName(val) {
    var v = String(val || '');
    if (v.indexOf(' - ') > -1) v = v.split(' - ').slice(1).join(' - ');
    v = v.split(' / ')[0].split(',')[0];
    return v.trim();
  }
  function partColour(part) {
    var w = part.toLowerCase().replace(/gray/g, 'grey').split(/[^a-z]+/).filter(Boolean);
    if (w.indexOf('camo') > -1) return 'camo';
    var base = null, mod = '';
    for (var i = w.length - 1; i >= 0; i--) {
      if (CHIP[w[i]]) { base = CHIP[w[i]]; break; }
    }
    if (w.indexOf('neon') > -1) { if (w.indexOf('yellow') > -1) base = '#e6ff00'; else if (w.indexOf('blue') > -1) base = '#00b7ff'; else base = '#39ff14'; }
    if (w.indexOf('dark') > -1 && base) mod = 'dark';
    if (w.indexOf('light') > -1 && base) mod = 'light';
    if (!base) return null;
    if (mod === 'dark') return 'color-mix(in srgb, ' + base + ' 65%, #000)';
    if (mod === 'light') return 'color-mix(in srgb, ' + base + ' 55%, #fff)';
    return base;
  }
  function chipStyle(val) {
    var parts = colourName(val).split(/\s*\/\s*/).filter(Boolean).slice(0, 3);
    var cols = parts.map(partColour).filter(Boolean);
    if (!cols.length) return '';
    var camo = 'repeating-radial-gradient(circle at 30% 40%, #4b5320 0 8px, #6b5a3a 8px 14px, #2f3a1c 14px 20px)';
    cols = cols.map(function (c) { return c === 'camo' ? null : c; });
    if (cols.length === 1) return cols[0] ? 'background:' + cols[0] : 'background:' + camo;
    var stops = [], n = cols.length;
    cols.forEach(function (c, i) {
      c = c || '#5b5b3a';
      stops.push(c + ' ' + Math.round(i * 100 / n) + '%', c + ' ' + Math.round((i + 1) * 100 / n) + '%');
    });
    return 'background:linear-gradient(135deg,' + stops.join(',') + ')';
  }
  /* A photo shared by several colours still belongs to the colour named in its file (Black_Front -> Black/Black) */
  function ownsImage(val, src) {
    var nrm = function (x) { return String(x).toLowerCase().replace(/[^a-z]/g, ''); };
    var pre = nrm(parse(src).prefix);
    if (!pre) return false;
    var parts = colourName(val).split(/\s*\/\s*/).map(nrm).filter(Boolean);
    var uniq = parts.filter(function (x, i) { return parts.indexOf(x) === i; });
    var j = parts.join('');
    return pre === j || pre === uniq.join('') || (j.length > 2 && pre.indexOf(j) === 0); /* Grey -> GreyMelange_Front */
  }
  /* The photo's label (alt text) names this colour */
  function labelOwns(val, src) {
    var k = src.split('?')[0].split('/').pop().split('.')[0];
    var c = nrm(colourName(val));
    if (!c) return false;
    for (var i = 0; i < media.length; i++) {
      if (media[i]._src && media[i]._src.split('?')[0].split('/').pop().split('.')[0] === k) return altColour(media[i]) === c;
    }
    return false;
  }
  function isHeroish(src) {
    var f = fname(src);
    return /(^|[_\s-])hero/.test(f) || /screenshot/.test(f);
  }
  function imageSwatches() {
    /* how many different colours point at each image: a shared image is not a real photo of that colour */
    var useCount = {};
    P.variants.forEach(function (v) {
      var src = variantImage(v);
      if (!src) return;
      var k = src.split('?')[0];
      useCount[k] = useCount[k] || {};
      useCount[k][colourName(v.option1 || v.title).toLowerCase()] = 1;
    });
    document.querySelectorAll('.product-form__input').forEach(function (fs) {
      if (fs.dataset.bmcImg) return;
      if (/option-name-(size|quantity|style)\b/i.test(fs.className)) return;
      var labels = [].slice.call(fs.querySelectorAll('.swatch-group > label[for]'));
      if (!labels.length) return;
      var items = labels.map(function (l) {
        var inp = document.getElementById(l.htmlFor);
        if (!inp) return null;
        var m = inp.id.match(/-(\d+)-\d+$/), pos = m ? Number(m[1]) : 1;
        var val = inp.value, v = null;
        for (var i = 0; i < P.variants.length; i++) if (P.variants[i]['option' + pos] === val) { v = P.variants[i]; break; }
        var src = variantImage(v);
        var shared = src && Object.keys(useCount[src.split('?')[0]] || {}).length > 1;
        if (shared && ownsImage(val, src)) shared = false;
        var chip = chipStyle(val);
        var labelled = src && labelOwns(val, src);
        var useChip = !src || ((shared || isHeroish(src)) && chip && !labelled);
        return { l: l, src: useChip ? '' : src, chip: chip, val: val, v: v };
      }).filter(Boolean);
      if (!items.length) return;
      /* Colours with no photo of their own are left off the page, as long as at least one colour has a photo */
      var withPhoto = items.filter(function (it) { return it.src; });
      if (withPhoto.length && withPhoto.length < items.length) {
        var lost = items.filter(function (it) { return !it.src; });
        var cur = null;
        lost.forEach(function (it) {
          var inp = document.getElementById(it.l.htmlFor);
          if (inp && inp.checked) cur = inp;
          it.l.remove();
          if (inp) { inp.disabled = true; inp.hidden = true; inp.setAttribute('aria-hidden', 'true'); }
        });
        if (cur) {
          var keep = withPhoto.filter(function (it) { return it.v && it.v.available !== false; })[0] || withPhoto[0];
          var kin = document.getElementById(keep.l.htmlFor);
          if (kin) { kin.checked = true; kin.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        items = withPhoto;
      }
      fs.dataset.bmcImg = '1';
      fs.classList.add('bmc-imgsw');
      items.forEach(function (it) {
        var name = colourName(it.val) || it.l.textContent.trim();
        it.l.title = it.val;
        it.l.classList.remove('swatch-variant-color');
        it.l.removeAttribute('style');
        it.l.classList.add('bmc-imgsw__btn');
        if (it.v && it.v.available === false) it.l.classList.add('is-soldout');
        var visual = it.src ? '<img src="' + sized(it.src, 160) + '" alt="" loading="lazy" width="80" height="80">'
          : '<span class="bmc-imgsw__chip" style="' + (it.chip || 'background:#ddd') + '"></span>';
        it.l.innerHTML = visual + '<span class="bmc-imgsw__name">' + name.replace(/</g, '&lt;') + '</span>';
      });
    });
  }

  function boot() { buildGallery(); placeDescription(); wording(); tidyLabels(); imageSwatches(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
